import React from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { APPSETTING } from '../../main';

// makes the logout button look like the neighbouring nav links (.nav-links a in css/reveen/style.css)
const navlinkbutton: React.CSSProperties = {
  background: 'none',
  border: 'none',
  padding: 0,
  fontFamily: 'inherit',
  fontSize: '0.84rem',
  fontWeight: 400,
  color: 'var(--muted)',
  cursor: 'pointer'
};

const ReveenLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const loggedin = !!(window.APPUSER && window.APPUSER.user);

  // clears the saved login and returns to the login page
  const handlelogout = () => {
    localStorage.removeItem(APPSETTING.appname + "user");
    window.APPUSER = null;
    navigate('/login');
  };

  // const opencart = () => {
  //   navigate('/shop');
  //   window.dispatchEvent(new CustomEvent('opencart'));
  // };

  return (
    <div className="app-wrapper">
      <nav>
        <div className="nav-inner">
          <Link to="/home" className="nav-logo">Reveen</Link>
          <div className="nav-links">
            {location.pathname === '/signup' ? (
              <Link to="/login">Login</Link>
            ) : location.pathname === '/login' ? (
              <Link to="/signup">Signup</Link>
            ) : loggedin ? (
              <>
                <Link to="/shop">Shop</Link>
                <Link to={loggedin ? '/subscriptions' : '/login'}>My Subscriptions</Link>
                <button type="button" onClick={handlelogout} className="nav-link-button" style={navlinkbutton}>Logout</button>
                {/* <Link to="/shop" onClick={opencart}>My Subscription</Link> */}
                {/* <button type="button" className="btn-blue" onClick={opencart}>
                  My Subscription
                </button> */}
              </>
            ) : (
              <>
                <Link to="/login">Login</Link>
                <Link to="/signup">Signup</Link>
              </>
            )}
          </div>
        </div>
      </nav>
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default ReveenLayout;